import { EventEmitter, inject, Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';

import { environment } from '../../environments/environment';
import { SignalRMessage } from '../_models/signalrMessage';

import { SettingsService } from './settings.service';
import { UserService } from './user.service';

declare const isEmpty: any;

@Injectable()
export class SignalRService {
    messageReceived = new EventEmitter<SignalRMessage>();
    connectionEstablished = new EventEmitter<Boolean>();

    protected _connectionIsEstablished = false;
    protected _hubConnection: HubConnection;
    enableSignalRLog: boolean = environment.enableSignalRLog;

    config: SettingsService = inject(SettingsService);
    userService: UserService = inject(UserService);

    constructor(private settingService: SettingsService) {
        this.inicializar();
    }

    protected createConnection() {
        if (this.enableSignalRLog)
            console.log('sincronizacaoHub', this._connectionIsEstablished);

        const url = `${this.settingService.baseApiUrl}/SincronizacaoHub`;
        this._hubConnection = new HubConnectionBuilder()
            .withUrl(url)
            .withAutomaticReconnect()
            .configureLogging(LogLevel.Error)
            .build();
    }

    public finalizar() {
        if (this._hubConnection == null)
            return;

        this._hubConnection.stop().then(() => {
            this._connectionIsEstablished = false;

            if (this.enableSignalRLog)
                console.log('Conexão Finalizada');

            this.connectionEstablished.emit(false);
        });
    }

    public inicializar() {
        if (this._hubConnection == null)
            this.createConnection();

        if (this._hubConnection.state === HubConnectionState.Disconnected)
            this.startConnection();
    }

    protected is_toConnectedUser(user_ids: number[], is_local: boolean = true) {
        var currentUser = is_local ? this.userService.userId() :  this.userService.user().id;

        if (isEmpty(user_ids) || user_ids.length === 0)
            return false;

        return user_ids.includes(currentUser);
    }

    protected startConnection(): void {
        if (this._connectionIsEstablished)
            return;

        let global = this;

        if (this.enableSignalRLog)
            console.log('Iniciando Conexão');

        this._hubConnection
            .start()
            .then(() => {
                this._connectionIsEstablished = true;
                if (this.enableSignalRLog)
                    console.log('Conexão Iniciada');

                this.connectionEstablished.emit(true);

                this._hubConnection.invoke('getConnectionId').then(function (connectionId) {
                    global.setSignalR(connectionId) .subscribe({
                        next: () => {},
                        error: (error) => console.log(error)
                    });
                });

                // Caso a conexão caia por algum motivo, esse trecho fará o trabalho para reconectar o cliente
                this._hubConnection.onclose(() => {
                    if (this._connectionIsEstablished) {
                        if (this.enableSignalRLog)
                            console.log('Conexão Interrompida. Tentando conectar novamente...');

                        this._connectionIsEstablished = false;
                        setTimeout(() => this.startConnection(), 5000);
                    }
                });
            })
            .catch(err => {
                if (this._connectionIsEstablished) {
                    if (this.enableSignalRLog)
                        console.log('Erro ao estabelecer conexão, tentando novamente...');

                    this._connectionIsEstablished = false;

                    setTimeout(() => {
                        this.startConnection();
                    }, 5000);
                }
            });
    }

    private setSignalR(context_connectionid: string) {
        let cookie_usuario = JSON.stringify(this.userService.user());

        const body = { context_connectionid, cookie_usuario };
        const url = '/account/set-signalR';
        return this.config.executePost({ url, body });
    }
}
